import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { parseSettlementStatus } from "../parseSettlementStatus";
import { parseEvent } from "../parseEvent";
import { parsePointsMetaData } from "../parsePointsMetadata";
import { safeString } from "../../helpers";
import { isSettledStatus } from "../../helpers";
import { parseTagsSelection } from "../parseTags";
import { EETAG } from "../../constants";
export function parseSelection(selection, events, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl) {
    var _a, _b, _c;
    const beEvent = events.get(selection.eventId);
    if (typeof beEvent !== "undefined") {
        const status = selection.isEarlyExitApplied ? "EarlyExit" : parseSettlementStatus(selection.settlementStatus);
        const event = parseEvent(beEvent, status, teamLogos, dateFormatter, dict, staticS3Host, swooshFeatureFlag, swooshBaseUrl);
        if (typeof event !== "undefined") {
            return {
                type: "regular",
                selectionId: selection.selectionId,
                status,
                displayOdds: safeString(selection.displayOdds),
                event,
                finalScore: safeString(selection.gameScore),
                marketBlurb: selection.marketBlurb,
                isInBetBoost: selection.isInBetBoost,
                marketDisplayName: safeString(selection.marketDisplayName),
                selectionDisplayName: selection.selectionDisplayName,
                isEarlyWinSettled: selection.isEarlyWinSettled,
                nestedSGPSelections: parseNestedSGPSelections(selection.nestedSGPSelections, beEvent, dict),
                legTracking: parsePointsMetaData(Object.assign(Object.assign({}, selection.pointsMetadata), { currentTotalPoints: getTruthyValue((_a = beEvent.marketMap) === null || _a === void 0 ? void 0 : _a[selection.marketId], (_b = selection.pointsMetadata) === null || _b === void 0 ? void 0 : _b.currentTotalPoints) }), !isSettledStatus(status)),
                replayData: selection.replayData,
                tag: ((_c = selection.tags) === null || _c === void 0 ? void 0 : _c.includes(EETAG)) || selection.isEarlyExitApplied ? parseTagsSelection(selection, dict) : undefined,
            };
        }
    }
    return undefined;
}
function parseNestedSGPSelections(nestedSGPSelections, event, dict) {
    if (!(nestedSGPSelections === null || nestedSGPSelections === void 0 ? void 0 : nestedSGPSelections.length)) {
        return undefined;
    }
    return nestedSGPSelections.map(nestedSelection => {
        var _a, _b, _c;
        const status = nestedSelection.isEarlyExitApplied ? "EarlyExit" : parseSettlementStatus(nestedSelection.settlementStatus);
        return ({
            type: "nested",
            selectionId: nestedSelection.selectionId,
            status,
            displayOdds: safeString(nestedSelection.displayOdds),
            finalScore: safeString(nestedSelection.gameScore),
            marketBlurb: nestedSelection.marketBlurb,
            isInBetBoost: nestedSelection.isInBetBoost,
            marketDisplayName: safeString(nestedSelection.marketDisplayName),
            selectionDisplayName: nestedSelection.selectionDisplayName,
            nestedSGPSelections: undefined,
            isEarlyWinSettled: nestedSelection.isEarlyWinSettled,
            legTracking: parsePointsMetaData(Object.assign(Object.assign({}, nestedSelection.pointsMetadata), { currentTotalPoints: getTruthyValue((_a = event.marketMap) === null || _a === void 0 ? void 0 : _a[nestedSelection.marketId], (_b = nestedSelection.pointsMetadata) === null || _b === void 0 ? void 0 : _b.currentTotalPoints) }), !isSettledStatus(parseSettlementStatus(nestedSelection.settlementStatus))),
            tag: ((_c = nestedSelection.tags) === null || _c === void 0 ? void 0 : _c.includes(EETAG)) || nestedSelection.isEarlyExitApplied ? parseTagsSelection(nestedSelection, dict) : undefined, // the check is for the value 1 since this is the representation of the early exit tag
        });
    });
}
//# sourceMappingURL=parseSelection.js.map